module.exports = __webpack_public_path__ + "preloader.empty.b05306969ff00c696b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/preloader/preloader.empty.png
// module id = 1030
// module chunks = 3